<nav class="sidebar-container">
    @if(isApplicant()) {
    <ul class="sidebar-nav">
        <li>
            <a (click)="navigateTo('/home')" routerLink="/home" routerLinkActive="active"><img
                    src="img/icons/Home_White.png" class="">Home</a>
        </li>
        @if(!needsUrgentContact()) {
        @if(hasApplication()) {
        <li>
            <a (click)="navigateTo('/hub')" routerLink="/hub" routerLinkActive="active"><img
                    src="img/icons/Application.png" class="">Application</a>
        </li>
        }
        @if(!isReturner() && hasApplication()) {
        <li>
            <a (click)="navigateTo('/interview')" routerLink="/interview" routerLinkActive="active"><img
                    src="img/icons/Interview.png" class="">Interview</a>
        </li>
        }
        @if(hasApplication()) {
        <li>
            <a (click)="navigateTo('/disclosure')" routerLink="/disclosure" routerLinkActive="active"><img
                    src="img/icons/Medical.png" class="">Medical</a>
        </li>
        }
        @if(isOrWasPlaced()) {
        <li>
            <a (click)="navigateTo('/placement')" routerLink="/placement" routerLinkActive="active"><img
                    src="img/icons/Placement.png" class="">Placement</a>
        </li>
        }
        @if(hasApplication() || hasPreviousApplication()) {
        <li>
            <a (click)="navigateTo('/payments')" routerLink="/payments" routerLinkActive="active"><img
                    src="img/icons/Payment.png" class="">Payments</a>
        </li>
        }
        @if(hasApplication() && canSelfPropose) {
        <li>
            <a (click)="navigateTo('/self-proposal')" routerLink="/self-proposal" routerLinkActive="active"><img
                    src="img/icons/Placement.png" class="">Camp
                Choices</a>
        </li>
        }
        @if(hasApplication() || isOrWasPlaced()) {
        <li>
            <a (click)="navigateTo('/flights')" routerLink="/flights" routerLinkActive="active"><img
                    src="img/icons/Flights.png" class="">Flights</a>
        </li>
        <li>
            <a (click)="navigateTo('/visa')" routerLink="/visa" routerLinkActive="active"><img src="img/icons/Visa.png"
                    class="">Visa</a>
        </li>
        <li>
            <a (click)="navigateTo('/group-cover')" routerLink="/group-cover" routerLinkActive="active"><img
                    src="img/icons/Insurance.png" class="">Group Cover</a>
        </li>
        }
        @if(canViewOrientation) {
        <li>
            <a (click)="navigateTo('/orientation')" routerLink="/orientation" routerLinkActive="active"><img
                    src="img/icons/Orientation.png" class="">Orientation</a>
        </li>
        }
        }
        <li>
            <a (click)="navigateTo('/contact-us')" routerLink="/contact-us" routerLinkActive="active"><img
                    src="img/icons/Contact_Us.png" class="">Contact us</a>
        </li>
    </ul>
    }
    @if(isSignedOut()) {
    <ul class="sidebar-nav">
        <li>
            <a (click)="navigateTo('/sign-in')" routerLink="/sign-in" routerLinkActive="active"><img
                    src="img/icons/Home_White.png" class="">Sign in</a>
        </li>
        <li>
            <a (click)="navigateTo('/contact-us')" routerLink="/contact-us" routerLinkActive="active"><img
                    src="img/icons/Contact_Us.png" class="">Contact us</a>
        </li>
    </ul>
    }
</nav>